import { useMutation } from "@tanstack/react-query";
import { apiGateway } from "@contexts";
import {
  FormBody,
  FormContentContainer,
  FormHeader,
  FullScreenLoader,
} from "../../../components";
import { useEffect } from "react";
import { useEnrolmentStatusContext } from "@contexts/EnrolmentStatusContext";
import {
  ErrorType,
  onQuestionChallengeAxiosErrorInterpreter,
} from "../hooks/onQuestionChallengeError";

interface VerifyLoginData {
  payload: { message: string };
}

interface Props {
  setShowUserIsVerifiedSnackbar: (show: boolean) => void;
  onError: (error: Error) => void;
}

export const VerifyClaveUnicaLogin: React.FC<Props> = ({
  setShowUserIsVerifiedSnackbar,
  onError,
}) => {
  const { getEnrolmentStatus } = useEnrolmentStatusContext();

  const { mutate } = useMutation({
    mutationFn: () =>
      apiGateway<VerifyLoginData, ErrorType>(
        {
          method: "post",
          url: "/enrolment/clave-unica/verify",
        },
        onQuestionChallengeAxiosErrorInterpreter,
      ),
    onSuccess: async () => {
      setShowUserIsVerifiedSnackbar(true);
      await getEnrolmentStatus();
    },
    onError,
  });
  useEffect(() => {
    // Notice that this will run twice in StricMode :(
    mutate();
  }, [mutate]);

  return (
    <>
      <FormHeader />
      <FormContentContainer flex={1} disableGutters>
        <FormBody justifyContent="center">
          <FullScreenLoader title={"Verificando identidad"} />
        </FormBody>
      </FormContentContainer>
    </>
  );
};
